<template>
  <div
    class="d-flex justify-content-center">
    <div
      class="cta bg-orchid text-white text-center p-3">
      <p class="pb-md">
        {{ message }}
      </p>
      <BaseButton
        :to="button.to"
        variant="secondary"
        :text="button.text"/>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { useStore } from 'vuex'

const store = useStore()

const props = defineProps({
  source: {
    type: String,
    default: 'cta'
  }
})
const toReturnItems = computed(() => store.state.closet.toReturnItems.length > 0)

const message = computed(() => {
  if (toReturnItems.value || props.source === 'case') {
    return 'Get free scheduled pickups with FedEx on your next case.'
  }
  return 'Time for your free pickup with FedEx.'
})

const button = computed(() => {
  return {
    text: 'Schedule Home Pickup',
    to: { name: 'account', query: { section: 'shipping-returns' } },
  }
})

</script>
<style lang="css" scoped>
.cta {
  border-radius: 4px;
  width: 90%;
}
</style>
